<template lang="pug">
v-container(fluid pa-0 class=" ")
  router-link(class="tw-font-medium text-link" :to="{ path: '/website/listing/' + this.$faker().datatype.number() }")
    div(class="tw-relative tw-m-8")
      div(
        class=" tw-absolute tw-z-10 tw-h-full tw-w-full tw-bg-gradient-to-b tw-from-gray-lighten-1 tw-to-gray-darken-4 tw-rounded-md"
      )
        v-img(:src="image" aspect-ratio="2" cover class="tw-h-full tw-w-full tw-rounded-md tw-opacity-75")
      div(class="tw-relative tw-z-20")
        div(class=" tw-h-48")
        v-row(dense class="tw-relative tw-z-20")
          v-col(cols="12" class=" tw-rounded tw-overflow-hidden tw-py-1 tw-h-auto")
            div(class=" tw-relative tw-z-30 tw-overflow-hidden tw-rounded-md  tw-m-4")
              v-row(no-gutters class=" tw-p-0")
                v-col(shrink)
                  v-row(no-gutters class="")
                    v-col(class="tw-m-3")
                      v-row(no-gutters align="center")
                        v-col(cols="9")
                          div(class=" tw-text-white tw-text-sm")
                            span For {{ this.$faker().random.arrayElement(['Rent', 'Sale']) }}
                          div(class=" tw-overflow-hidden tw-mr-4 tw-pt-1 tw-font-medium tw-text-white")
                            router-link(
                              class="tw-font-bold tw-text-white tw-whitespace-no-wrap"
                              :to="{ path: 'listing/' + this.$faker().datatype.number() }"
                            )
                              span(class="tw-text-white") {{ this.$faker().lorem.sentence(3) }}
                  v-row(no-gutters class="tw-px-2")
                    v-col(cols="3")
                      div(class="tw-text-xl tw-text-white tw-font-bold tw-text-left")
                        span ${{ this.$faker().finance.amount(10000, 100000, 0) }}
                  v-row(no-gutters justify="start" class="tw-px-2 tw-text-white")
                    v-col(cols="auto" class=" tw-items-center tw-mb-4 tw-text-white ")
                      v-row(dense justify="center" class="tw-pt-2 tw-pb-0")
                        v-col(cols="auto" class="tw-mr-2")
                          v-row(no-gutters align="center" justify="center")
                            v-col(cols="auto" class=" tw-text-center")
                              span(class="tw-ml-1  tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Beds

                        v-col(cols="auto" class="tw-mr-2")
                          v-row(no-gutters align="center" justify="center")
                            v-col(cols="auto" class=" tw-text-center")
                              span(class="tw-ml-1  tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Bath

                        v-col(cols="auto" class="tw-mr-2")
                          v-row(no-gutters align="center" justify="center")
                            v-col(cols="auto" class=" tw-text-center")
                              span(class="tw-ml-1 tw-text-sm") {{ this.$faker().datatype.number({ min: 200, max: 800 }) }} m <sup>2</sup>

                  v-row(no-gutters justify="space-between" align="center" class="tw-px-2")
                    v-col(cols="auto")
                      v-row(no-gutters align="center" justify="center")
                        v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                          div(class="tw-w-6 tw-h-6 tw-flex ")
                            v-icon(color="white" class="tw-mx-auto") mdi-map-marker-outline
                        v-col(cols="auto" class=" tw-text-center")
                          span(class="tw-ml-1 tw-text-white") {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}
</template>
<script>
export default {
  data() {
    return {
      image: null,
    };
  },
  mounted() {
    this.image = this.sampleWebsiteImage('listing', 450, 250, this.$faker().datatype.number(1000));
  },
};
</script>
